import { vuexfireMutations, firestoreAction } from 'vuexfire'

import firebase from 'firebase/app';
import firebase_api from "@/firebase/firebase_api"; 
import Vue from "vue"
import Vuex from 'vuex'
import axios from 'axios'

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

Vue.use(Vuex)

const store = new Vuex.Store({
  // setup the reactive todos property
  deltaTimeStamp: null,
  state: {
    user:null,
    credit: {
      credit: 0
    },
    labelRef: null,
    editor: {
      state: false,
      id: null,
      value: null
    },
    minimize: false,
    myClubs: [],
    onLine: null,
    role: null,
    demo: {
      active: false,
      admin: false,
      tuto: 0,
      badButton: false,
      idClub: null,
      idTournoi: null,
      idPartie: null,
      tutoriel: null,
      nbEquipes: 0,
      equipeCompleted: false
    },
    tutos: null,
    helpChapitres: null
  },

  mutations: 
    vuexfireMutations,
  
    
  getters: {
    getDeltaTimeStamp: state=>{
      return state.deltaTimeStamp;
    },
    getTutos: state=>{
      return state.tutos;
    },
    getDemo: state=>{
      return state.demo;
    },
    getRole: state=>{
      return state.role;
    },
    getMyClubs: state=> {
      return state.myClubs;
    },
  	getUser: state => {
    	return state.user;
    },
    getCredit: state=> {
      return state.credit;
    },
    getHelpChapitres: state =>{
      return state.helpChapitres;
    },
    getLabelRef: state =>{
      return state.labelRef;
    },
    getEditor: state=> {
      return state.editor;
    },
    getMinimize: state=> {
      return state.minimize;
    },
    onLastStatus: state=>{
      
      return state.onLine;
    }
  // other getters
  }, 
  
  actions: {
    async setDeltaTimeStamp (context, params) {
        const functions = firebase.app().functions('europe-west1');
        await functions.httpsCallable("stamp")().then(res=>{
          var d = new Date();
          var localD = d.getTime();
         
          context.state.deltaTimeStamp = res.data.timeStamp - localD;
        
        })
    },
    setTutoSaveConcours(context, params) {
      context.state.demo.idClub = params.idClub;
      context.state.demo.idTournoi = params.idTournoi;
      context.state.demo.idPartie = params.idPartie;
    },
    
    setTutoriel: firestoreAction(async (context, params)=> {
      context.state.demo.tutoriel = params.tutoriel;
      context.state.demo.nbEquipes = 0;
      context.state.demo.equipeCompleted = false;
      if (params.tutoriel !=null) {
         
         var docTuto = firebase_api.api.getDb().collection("tuto").doc(params.tutoriel)
    
         await context.bindFirestoreRef('tutos',docTuto, {wait: true}).then((stranger)=>{
          
         })
      } 
      else {
        context.state.tutos = null;   
      }
    }),
    setUpdateDemo(context, params) {
      context.state.demo = params;
    },
    setDemo(context, params) {
      context.state.demo.active = params.demo;
      
    },
    setTuto(context, params) {
      context.state.demo.tuto = params.tuto;

    },
    setTutoBadButton(context, params) {
      context.state.demo.badButton = params.badButton;
    },
    setDemoAdmin(context, params) {
      context.state.demo.admin = params.admin;
    },
    setRole(context, params) {
        context.state.role = params.role;
    },
    setonLastStatus(context, params) {
          if (context.state.onLine==null) {
         
                context.state.onLine = params.onLine;
                if (!context.state.onLine)
                    firebase_api.api.getDb().disableNetwork();
          }
          else if (context.state.onLine!=params.onLine) {
              context.state.onLine = params.onLine;
              if (context.state.onLine) {
             
                firebase_api.api.getDb().enableNetwork();
              }
              else {
            
                firebase_api.api.getDb().disableNetwork();
              }
          }
    }
    ,
    setMinimize(context, params) {
        context.state.minimize = params.value;
    },
    editorOnOff (context, params) {
      context.state.editor.id = params.id;
      context.state.editor.value = params.value;
      context.state.editor.state = !context.state.editor.state;
    },
    initLabel: firestoreAction(async (context, fct)=> {
      await context.bindFirestoreRef('labelRef', firebase_api.api.getDb().collection("label").doc("fr"), {wait: true});
      await context.bindFirestoreRef('helpChapitres', firebase_api.api.getDb().collection("videos").doc("chapitres"), {wait: true})
     /*
        console.log(data);
        context.labelRef = labelRef
        */
       fct();
     /*
        console.log(data);
        context.labelRef = labelRef
        */
       
    }),
    initClubs: firestoreAction(async (context, fct) => {
     
      if (firebase.auth().currentUser!=null) {
        var idUser = firebase.auth().currentUser.uid;
       
        var constructWhere = "users." + idUser + ".authId";
        var notAdmin = true;
        
        if (typeof(context.state.user.adminSite)!="undefined") 
          if (context.state.user.adminSite)
              notAdmin = false;
        if (notAdmin) {
              await context.bindFirestoreRef('myClubs', firebase_api.api.getDb().collection("club")
                .where(constructWhere, "==", idUser)
                , {wait : true})
        }
        else
            
            await context.bindFirestoreRef('myClubs', firebase_api.api.getDb().collection("club")
                , {wait : true})

        fct();
      }
      else {
        context.state.myClubs = [];
        fct();
      }
    }),
  	init: firestoreAction(async (context, fct)=>{
      
      if (firebase.auth().currentUser!=null) {
       
        await firebase_api.api.getDb().collection('user').doc(firebase.auth().currentUser.email).get()
          .then(async (snapshot) => {
              if (snapshot.exists) {
                  var userDoc = snapshot;
                  var userData = snapshot.data();
                 
                  userData.authId = firebase.auth().currentUser.uid;
                  if (!userData.login) {
                      userDoc.ref.update({
                        authId:  userData.authId,
                        login: true
                      })
                  }
                  if (userData.displayName == null) {
                    userDoc.ref.update({
                      displayName:  firebase.auth().currentUser.displayName
                    })
                  }
                  await context.bindFirestoreRef('user', firebase_api.api.getDb().collection("user").doc(userDoc.id), {wait: true});
                  
                  context.bindFirestoreRef('credit', firebase_api.api.getDb().collection('credit').doc(userData.authId), {wait: true})
                    .then((resCredit)=> {
                        if (resCredit == null)
                          context.state.credit = {
                            credit: 0
                          }
                    })
              } 
              else {
              
                var userData = {};
               
                userData.displayName = firebase.auth().currentUser.displayName;
                userData.email = firebase.auth().currentUser.email;
                userData.joueurs = [];
                userData.clubs = [];
                userData.authId = firebase.auth().currentUser.uid;
                userData.login = true;
               
                var userAdd = await firebase_api.api.getDb().collection('user').doc(userData.email).set(
                  userData
                )
                
                await context.bindFirestoreRef('user', firebase_api.api.getDb().collection("user").doc(userData.email), {wait: true});
               
                context.bindFirestoreRef('credit', firebase_api.api.getDb().collection('credit').doc(userData.authId), {wait: true})
                .then((resCredit)=> {
                    if (resCredit == null)
                      context.state.credit = {
                        credit: 0
                      }
                })
               
              } 
              
                  
              context.dispatch("initClubs", ()=>{
                  fct();
              });
          })
         
      }
      else {
        context.state.user = null;
        fct();
      }
  	}),
  }
})

export default {
	store: store
}